import { RecordProperties } from './../../record-model';
import { LayoutService } from './../../layout.service';
import {
  Component,
  ElementRef,
  Input,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { RecordModel, RecordCategory, RecordLine } from '../../record-model';
import {
  ModuleStructure,
  Field,
  Section,
  FieldDataType,
  FieldPCAlignment,
} from 'src/app/models/module-structure';

@Component({
  selector: 'app-field, [app-field]',
  templateUrl: './field.component.html',
  styleUrls: ['./field.component.less'],
})
export class FieldComponent implements OnInit, OnDestroy {
  @Input() moduleStructure: ModuleStructure;
  @Input() field: Field;
  @Input() recordModel: RecordModel;
  @Input() section: Section;
  @Input() lineId = 0;
  @Input() forceLabelVisible = false;
  @Input() actionType = '';
  private inTableValue = false;
  @Input() set inTable(value: boolean) {
    this.inTableValue = value === true;
    if (this.recordProperty != null) {
      this.recordProperty.InTable = this.inTableValue;
    }
    if (this.inTableValue) {
      this.initialized = false;
      if (this.recordProperty != null) {
        this.recordProperty.EditMode = false;
      }
    }
  }

  get inTable(): boolean {
    return this.inTableValue;
  }
  @Input() parentClass = '';

  initialized = false;
  scanControlVal: any;

  private recordPropertyValue: RecordProperties;
  @Input() set recordProperty(value: RecordProperties) {
    this.recordPropertyValue = value;
    if (this.recordPropertyValue != null) {
      this.recordPropertyValue.InTable = this.inTableValue;
    }
    if (this.inTableValue && this.recordPropertyValue != null) {
      this.recordPropertyValue.EditMode = false;
    }
  }

  get recordProperty(): RecordProperties {
    return this.recordPropertyValue;
  }
  @Input() recordCategory: RecordCategory;
  @Input() recordLine: RecordLine;

  @Input() set scanControl(val: any) {
    this.scanControlVal = val;
  }

  get scanControl() {
    return this.scanControlVal;
  }

  FieldDataType = FieldDataType;

  labelWidth = 6;
  inputWidth = 14;

  screenSize = '';

  constructor(
    private layoutService: LayoutService,
    private elementRef: ElementRef<HTMLElement>,
  ) {}
  ngOnDestroy(): void {}

  ngOnInit(): void {
    const date = new Date();

    if (!this.recordCategory) {
      this.recordCategory = this.recordModel.Categories.find(
        (c) => c.Id === this.section.XmlTagName
      );
    }

    if (!this.recordLine) {
      this.recordLine = this.recordCategory.Lines.find(
        (l) => l.Id === this.lineId
      );
    }

    if (!this.recordProperty && this.recordLine.Properties !== undefined) {
      this.recordProperty = this.recordLine.Properties.find(
        (c) => c.Name === this.field.PropertyName
      );
    }

    if (this.recordProperty == null) {
      return;
    }
    this.recordProperty.InTable = this.inTable;
    this.screenSize = this.layoutService.screenSize;
    this.adjustWidth();

    // this.layoutService.screenSizeEmitter.subscribe((a) => {
    //   this.screenSize = a;
    //   this.adjustWidth();
    // });
  }

  adjustWidth() {
    if (
      (this.section.Type === 2 && !this.forceLabelVisible) ||
      !this.field.AdditionalInformationParsed.LabelVisible
    ) {
      this.inputWidth = 24;
    } else if (
      this.screenSize === 'large' ||
      this.screenSize === 'x-large' ||
      this.screenSize === 'medium'
    ) {
      if (this.field.PCAlignment === FieldPCAlignment.Extended) {
        this.labelWidth = 4;
        this.inputWidth = 20;
      } else {
        this.labelWidth = 10;
        this.inputWidth = 14;
      }
    } else if (this.screenSize === 'medium') {
      this.labelWidth = 6;
      this.inputWidth = 18;
    } else {
      this.labelWidth = 24;
      this.inputWidth = 24;
    }
  }

  mouseLeave() {
    this.recordProperty.EditMode = false;
  }

  mouseEnter() {
    this.recordProperty.EditMode = true;
    this.initialized = true;
    if (this.inTable) {
      this.focusEditor(3);
    }
  }

  private focusEditor(attemptsRemaining: number): void {
    setTimeout(() => {
      const selector =
        'input:not([type="hidden"]):not([readonly]):not([disabled]), textarea:not([readonly]):not([disabled]), [contenteditable="true"], .ant-select:not(.ant-select-disabled) .ant-select-selector';
      const target = this.elementRef.nativeElement.querySelector(
        selector,
      ) as HTMLElement;
      if (target != null && target.offsetParent !== null) {
        target.focus();
      } else if (attemptsRemaining > 1) {
        this.focusEditor(attemptsRemaining - 1);
      }
    }, attemptsRemaining === 3 ? 0 : 25);
  }
}
